// client/src/components/LanguageSelector.jsx
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe } from 'react-icons/fa';

const languages = [
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' }
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const currentLang = i18n.language;
  const isRTL = i18n.dir() === 'rtl';

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('i18nextLng', langCode);
    document.documentElement.dir = langCode === 'ar' ? 'rtl' : 'ltr';
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1 bg-gray-700/80 hover:bg-gray-600 px-2 py-1 rounded-full text-sm transition"
      >
        <FaGlobe className="text-yellow-400 text-sm" />
        <span className="hidden sm:inline text-white">
          {languages.find(l => l.code === currentLang)?.name || 'Language'}
        </span>
      </button>
      {isOpen && (
        <div 
          className={`absolute ${isRTL ? 'right-0' : 'left-0'} mt-2 min-w-[120px] max-w-[90vw] bg-gray-800 rounded-lg shadow-lg border border-yellow-500/30 z-50`}
        >
          {languages.map(lang => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-700 transition flex items-center gap-2 ${
                currentLang === lang.code ? 'text-yellow-400' : 'text-white'
              }`}
            >
              <span>{lang.flag}</span> {lang.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;